import { Moment } from 'moment';
import { SelectOption } from 'global';

import { PaymentType } from './PaymentType';
import { CustomerType } from './CustomerType';
import { CreateDateRange } from './CreateDateRange';
import { EquipmentType } from './EquipmentType';

import { DealSheetRulesFilterType } from '../../types';

export const componentCardToTypeMapper = {
  [DealSheetRulesFilterType.CREATE_DATE_RANGE]: { label: 'Created', component: CreateDateRange },
  [DealSheetRulesFilterType.CUSTOMER_TYPE]: { label: 'Customer Type', component: CustomerType },
  [DealSheetRulesFilterType.PAYMENT_TYPE]: { label: 'Payment Type', component: PaymentType },
  [DealSheetRulesFilterType.EQUIPMENT_TYPE]: { label: 'Equipment Type', component: EquipmentType },
};

export type DealSheetRulesFilters = {
  [DealSheetRulesFilterType.CREATE_DATE_RANGE]: {
    from: Moment;
    to: Moment;
  };
  [DealSheetRulesFilterType.CUSTOMER_TYPE]: SelectOption[];
  [DealSheetRulesFilterType.PAYMENT_TYPE]: SelectOption[];
  [DealSheetRulesFilterType.EQUIPMENT_TYPE]: SelectOption[];
};
